export interface IModelRegisterRequest {
  email: string;
  password: string;
}

export interface IModelRegisterResponse {
  id: number;
  email: string;
  password: string;
  avatar: string;
  status: string;
  lastLoginAt: string | null;
  lastActiveAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;
}

export class ModelRegisterResponse {
  id: number;
  email: string;
  password: string;
  avatar: string;
  status: string;
  lastLoginAt: string | null;
  lastActiveAt: string | null;
  createdAt: string | null;
  updatedAt: string | null;

  constructor(props: IModelRegisterResponse = {} as IModelRegisterResponse) {
    this.id = props.id;
    this.email = props.email;
    this.password = props.password;
    this.avatar = props.avatar;
    this.status = props.status;
    this.lastLoginAt = props.lastLoginAt;
    this.lastActiveAt = props.lastActiveAt;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
  }
}
